import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LogoSlider from "./components/LogoSlider";
import Process from "./components/Process";
import Features from "./components/Feature";
import PhotoGallery from "./components/PhotoGallery";
import Testimonial from "./components/Testimonial";
import ContactArea from "./components/ContactArea";
import Footer from "./components/Footer";
import './index.css';

function App() {
  return (
    <>
    <Navbar/>
   <Hero/>
   <LogoSlider/>
   <Process/>
   <Features/>
   <PhotoGallery/>
   <Testimonial/>
   <ContactArea/>
   <Footer/>
   </>
  );
}

export default App;
